<template>
  <footer class="relative footer-text">
    <!-- Background Image -->
    <div class="absolute inset-0 -z-10">
      <img
        src="@/assets/Menu/Footer.png"
        alt="Footer Background"
        class="w-full h-full object-cover object-center blur-sm"
      />
      <div class="absolute inset-0 footer-overlay"></div>
    </div>

    <div class="relative px-4 py-20 max-w-5xl mx-auto text-center space-y-10">
      <!-- Call to Action -->
      <div>
        <h2
          class="font-['Cinzel'] text-[28px] sm:text-[40px] md:text-[48px] lg:text-[55px] leading-tight uppercase font-normal footer-title"
        >
          {{ t("footer.title") }}
        </h2>
      </div>

      <!-- Contact Info -->
      <div
        class="grid grid-cols-1 md:grid-cols-3 gap-10 text-left font-['DM_Sans'] text-[16px] sm:text-[18px] md:text-[20px] font-normal max-w-8xl mx-auto"
      >
        <!-- Location -->
        <div class="flex items-start gap-4">
          <img
            src="@/assets/icons/map-pin-fill.svg"
            alt="Location"
            class="w-6 h-6 mt-1"
          />
          <div>
            <p :class="alignClass">
              {{ t("footer.location") }}
            </p>
          </div>
        </div>

        <!-- Phone -->
        <div class="flex items-start gap-4">
          <img
            src="@/assets/icons/phone-fill.svg"
            alt="Phone"
            class="w-6 h-6 mt-1"
          />
          <div>
            <p :class="alignClass">
              {{ t("footer.phone") }}<br />
              +20-100-383-4294
            </p>
          </div>
        </div>

        <!-- Email -->
        <div class="flex items-start gap-4">
          <img src="@/assets/icons/mail.svg" alt="Email" class="w-6 h-6 mt-1" />
          <div>
            <p :class="alignClass">
              {{ t("footer.email") }}<br />
              tuscany.hous@gmail.com
            </p>
          </div>
        </div>
      </div>

      <!-- Reserve a Table Button -->
      <div>
        <button
          @click="handleReserve"
          class="footer-btn px-6 py-3 text-[16px] sm:text-[18px] md:text-[20px] font-['Cormorant_SC'] font-normal tracking-wide transition inline-block text-center"
        >
          {{ t("footer.reserve") }}
        </button>
      </div>

      <!-- Logo -->
      <div class="flex justify-center">
        <router-link to="/">
          <img
            src="@/assets/logo.png"
            alt="Tuscany House Logo"
            class="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain cursor-pointer"
          />
        </router-link>
      </div>

      <!-- Copyright -->
      <p class="footer-copy font-['DM_Sans'] text-[14px] sm:text-[16px] md:text-[20px] mt-6">
        {{ t("footer.rights") }}
      </p>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";
import { computed } from "vue";
import { getAuth } from "firebase/auth";
import { useRouter } from "vue-router";

const { t, locale } = useI18n();

const alignClass = computed(() => {
  return locale.value === "ar" ? "text-right" : "text-left";
});

const auth = getAuth();
const router = useRouter();

function handleReserve() {
  const user = auth.currentUser;
  if (user && user.emailVerified) {
    router.push("/bookingduration");
  } else {
    router.push("/login");
  }
}
</script>

<style scoped>
.footer-overlay {
  background: var(--menu-hero-overlay);
}

.footer-title {
  color: var(--primary);
}

.footer-text {
  color: var(--on-surface);
}

.footer-btn {
  background: var(--primary);
  border: 1px solid var(--border);
  color: var(--on-primary);
}
.footer-btn:hover {
  background: var(--primary-200);
}

.footer-copy {
  color: var(--footer-detail);
}
.footer-text {
  color: var(--footer-detail);
}

</style>
